module.exports = __webpack_public_path__ + "static/media/main-about-preview.cde34d1d.png";